export default __webpack_public_path__ + "images/import-xlsx.svg";